import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

const hotelRoom = () => {
  jQuery(document).ready(function($) {
    const body = $('body');

    // Hotel room modal
    const hotelRoomModal = $('.hotel-room-modal');
    if (hotelRoomModal.length) {
      $(document).on('click', '.hotel-room-trigger', function(e) {
        e.preventDefault();

        const _this = $(this);
        const url = _this.attr('href');
        const roomID = _this.data('room-id');
        const title = _this.data('title');
        const closeTarget = _this.data('close-target');
        const hotelRoomClose = hotelRoomModal.find('.hotel-room-close');
        const hotelRoomInnerContent = hotelRoomModal.find('.hotel-room-inner-content');
        const loadedRoomID = hotelRoomModal.data('room-id');

        helpers.pushStateHistory(url, true);
        body.addClass('hotel-room-mode');
        helpers.stopBodyScrolling(true);

        $(document).trigger(constants.EVENT_VIRTUAL_PAGEVIEW, [url, title]);

        if (closeTarget) {
          hotelRoomClose.data('close-target', closeTarget);
        }

        if (!loadedRoomID || loadedRoomID !== roomID) {
          hotelRoomModal.removeClass('loaded');

          hotelRoomInnerContent.load(('' + url + ' .hotel-room-inner-sections'), function () {
            $(document).trigger(constants.EVENT_HOTEL_ROOM_MODAL_LOADED);
            $(document).trigger(constants.EVENT_BOOKING_FORM_LOADED);

            setTimeout(function(){
              const hotelGallery = hotelRoomModal.find('.section-hotel-hp-gallery .slider');

              hotelGallery.slick('refresh');
            }, 100);

            hotelRoomModal.data('room-id', roomID);
            hotelRoomModal.addClass('loaded');

            const hotelRoomSubmit = hotelRoomModal.find('.hotel-room-submit');
            if (hotelRoomSubmit.length) {
              hotelRoomSubmit.each(function() {
                const _this = $(this);

                _this.on('click', function(e) {
                  e.stopPropagation();

                  if (window.innerWidth >= 992) {
                    // desktop
                    hotelRoomModal.find('.booking-daterange-picker').first().data('daterangepicker').show();
                  } else if (window.innerWidth < 992) {
                    // Mobile
                    hotelRoomModal.find('.hotel-mobile-booking-modal').addClass('show');
                    body.addClass('modal-open');
                  }

                  return false;
                });
              });
            }
          });
        }
      });

      $(document).on('click', '.hotel-room-close', function(e) {
        e.preventDefault();

        const _this = $(this);
        const url = _this.attr('href');
        const title = _this.data('title');
        const closeTarget = _this.data('close-target');

        $(document).trigger(constants.EVENT_VIRTUAL_PAGEVIEW, [url, title]);

        helpers.stopBodyScrolling(false);
        helpers.pushStateHistory(url, true);
        body.removeClass('hotel-room-mode');

        if (closeTarget) {
          window.location.hash = closeTarget;
        }
      });
    }
  });
};

export default hotelRoom;



// WEBPACK FOOTER //
// ./scripts/routes/modules/hotelRoom.js